import { ObjectType, Field, ID, Float, InputType, Int } from 'type-graphql'
import { ScalarObject } from '@things-factory/shell'
import { KpiMetricValue } from './kpi-metric-value'
import { KpiPeriodType } from '../kpi/kpi'

@InputType({
  description: 'Input type for creating a new metric value. Used in mutations to provide metric value details.'
})
export class NewKpiMetricValue {
  @Field(type => ID, { description: 'ID of the metric to which this value belongs.' })
  metricId: string

  @Field({ description: 'Date or period for which this metric value is recorded (e.g., day, month, quarter, range).' })
  valueDate: string

  @Field(type => KpiPeriodType, { description: 'Aggregation period type for this metric value.' })
  periodType: KpiPeriodType

  @Field(type => Float, { description: 'The value for this metric and period.' })
  value: number

  @Field({ nullable: true, description: 'Unit of measurement for this metric value.' })
  unit?: string

  @Field(type => ScalarObject, {
    nullable: true,
    description:
      'Extended or non-numeric information related to this metric value, stored as JSON. Can include status, comments, or other metadata.'
  })
  meta?: any

  @Field({ nullable: true, description: 'Organizational unit for this value (project, department, company, employee, etc.)' })
  org?: string
}

@InputType({
  description: 'Input type for updating an existing metric value. Used in mutations to patch metric value details.'
})
export class KpiMetricValuePatch {
  @Field(type => ID, { nullable: true, description: 'ID of the metric value to update.' })
  id?: string

  @Field(type => ID, { nullable: true, description: 'ID of the metric to which this value belongs.' })
  metricId?: string

  @Field({
    nullable: true,
    description: 'Date or period for which this metric value is recorded (e.g., day, month, quarter, range).'
  })
  valueDate?: string

  @Field(type => KpiPeriodType, { nullable: true, description: 'Aggregation period type for this metric value.' })
  periodType?: KpiPeriodType

  @Field(type => Float, { nullable: true, description: 'The value for this metric and period.' })
  value?: number

  @Field({ nullable: true, description: 'Unit of measurement for this metric value.' })
  unit?: string

  @Field(type => ScalarObject, {
    nullable: true,
    description:
      'Extended or non-numeric information related to this metric value, stored as JSON. Can include status, comments, or other metadata.'
  })
  meta?: any

  @Field({ nullable: true, description: 'Organizational unit for this value (project, department, company, employee, etc.)' })
  org?: string

  @Field({ nullable: true, description: 'Custom flag for update operations (internal use).' })
  cuFlag?: string
}

@ObjectType()
export class KpiMetricValueList {
  @Field(type => [KpiMetricValue])
  items: KpiMetricValue[]

  @Field(type => Int)
  total: number
}
